//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data(){
        return {
            img:'https://static.soyoung.com/sy-pre/bg_img-1566375004168.png',
           show:false
        }
    },
    created() {
       
    },
    methods:{
        showoast(){
            this.show = true
        },
        closeClick(){
            this.show = false
        }
    }
}
